module.exports = __webpack_public_path__ + "static/beetroot-7300315ec0e03e55c30663c8cbcd925b.svg";